/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NextQueueItemResponse } from '../../models/next-queue-item-response';

export interface ApiIdpQueueNextQueueItemGet$Params {
}

export function apiIdpQueueNextQueueItemGet(http: HttpClient, rootUrl: string, params?: ApiIdpQueueNextQueueItemGet$Params, context?: HttpContext): Observable<StrictHttpResponse<NextQueueItemResponse>> {
  const rb = new RequestBuilder(rootUrl, apiIdpQueueNextQueueItemGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NextQueueItemResponse>;
    })
  );
}

apiIdpQueueNextQueueItemGet.PATH = '/api/IdpQueue/next-queue-item';
